import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router";
import App from './App';
import reportWebVitals from './reportWebVitals';
import {ReactQueryProvider} from "./provider/query.provider";
import {Layout} from "./components/Layout";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <ReactQueryProvider>
              {/*<BrowserRouter>
              <Routes>
                  <Route path="/" element={<App />} />
              </Routes>
          </BrowserRouter>*/}
              <App/>
      </ReactQueryProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
